import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty, pickBy } from 'lodash';

type Primitive = string | boolean | number;

@Pipe({
    name: 'filter',
})
export class FilterPipe implements PipeTransform {
    transform(
        collection: Record<string, any>[],
        predicate: Record<string, Primitive>
    ): Record<string, any>[] {
        predicate = pickBy(predicate);
        if (!collection?.length || isEmpty(predicate)) {
            return collection;
        }
        const entries = Object.entries(predicate);
        return collection.filter((item) =>
            entries.every(([key, value]) =>
                item[key]
                    ?.toString()
                    ?.toLowerCase()
                    ?.includes(value.toString().toLowerCase())
            )
        );
    }
}
